import React from "react";
import Icon from "@material-ui/core/Icon";

/**
 * Up or Down button to move a sequenceable item one space
 * up or down in the sequence it is a part of.
 * <MoveButton delta={} handleChange={} moveItem={} maxSequence={} type={} plType={} />
 **/
const MoveButton = (props) => {
  const { delta, handleChange, moveItem, maxSequence, type, plType } = props;
  const buttonText = delta > 0 ? "arrow_downward" : "arrow_upward";
  const isValidOption =
    /*
     * If moving to a greater sequence number,
     * must not have the highest sequence in the list already
     */
    (delta > 0 && moveItem.sequence < maxSequence) ||
    /*
     * If moving to a lower sequence number,
     * must not be moving lower than sequence: 1.
     */
    (delta < 0 && moveItem.sequence > 1);
  return isValidOption ? (
    <button
      className="btn btn-link"
      value={moveItem.sequence + delta}
      style={{ display: "block" }}
      onClick={(e) =>
        handleChange(
          {
            type: type,
            plType: plType,
            id: moveItem.id,
            key: moveItem.stateKey,
            index: moveItem.index,
            unitIx: moveItem.unitIndex,
            field: "sequence",
            value: moveItem.sequence + delta,
            updateStateAfterReq: true,
          },
          e
        )
      }
    >
      <Icon className="mr-2 text-primary">{buttonText}</Icon>
    </button>
  ) : (
    ""
  );
};

export default MoveButton;
